import { Component, Input, Injectable, Inject, OnInit, ViewChild, EventEmitter, Output, ElementRef, Renderer, HostListener } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Http, Response, Headers } from '@angular/http';
import { fade, slowfade, show, select, highlight, videoPanel, newsContent, devNotice, rotateFull, enabled, gameFeature, fadeInUp, bottomArea } from '../app.animations';

import { StoreService } from '../services/store.service';

import { environment } from '../environment';
import { DevTracker } from '../models/devtracker';
import { Statistic } from '../models/statistics';
import { News } from '../models/news';
import { Video } from '../models/video';

declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  animations: [fade, slowfade, show, select, highlight, videoPanel, newsContent, devNotice, rotateFull, enabled, gameFeature, fadeInUp, bottomArea ]
})
export class HomeComponent implements OnInit {
	
	@ViewChild('Top') Top;
	@ViewChild('Buttons') Buttons;
	@ViewChild('Slider') Slider;
	@ViewChild('Updates') Updates;
	@ViewChild('Stats') Stats;
	
	@Input() myStartVal: number;
	@Input() myEndVal: number;

	loaded = false;
	scrollState = 'hidden';
	viewingSection: number;
	lastOffset: number;
	showVideo = 'true';

	news: News;
	devPosts: DevTracker;
	statistics: Statistic;
	videos: Video;

	yt: any; // YOOT-TOWER
	fold: any;
	timer: any;
	player = [];
	tracker = 0;
	updates = 0;
	networkerr: string;
	playerVolume: number;

	showLogo: boolean;
	bottomSignup: boolean;
	showInformation: boolean;
	showVideoPlayer = false;

	// Video Player
	videoHighlight: any;
	videoSelection: any;

	// Status buttons for page items
	v = 0; // videos
	b = 0; // buttons
	f = 0; // Game Features
	s = 0; // statistics

	showVideos = false;
	numberOfVideos = 0;
	videosOnScreen = 4;
	statsOnScreen = 3;
	buttonsOnScreen = 4;
	numberOfStatistics = 3;
	buttons = [1,2,3,4];

	// Settings for 'Show More...' links
	expandedChars = 100000;
	condensedChars = 400;
	showIntro = true;
	showNotice = false;
	limit = [this.condensedChars, this.condensedChars];
	expandNews = [];

	citizens = 0;
	totalraised = 0;
	socialfollowers = 0;
	sections = [];

	loadedPosts = 'null';
	loadedUpdates = 'null';

	// App construct
	constructor(private http : Http,
				private storeService: StoreService) {
		this.sections = [ this.Top, this.Buttons, this.Slider, this.Updates, this.Stats ];
    }

	whatSection() {
	    let topOffset = 0;
	    for (var i = 0; i <= this.sections.length-1; i++) {
	      topOffset = this.sections[i].nativeElement.offsetTop;
	      if ( window.pageYOffset > topOffset  ) this.viewingSection = i;
	    }
	    return this.viewingSection;
	}

	goToSection(set?) {
		this.viewingSection = set;
		let y = this.sections[set].nativeElement.offsetTop;
		this.scrollTo( y );
	}

  	getFilms(): Promise<Video> {
  		return this.http
  			.get(`${environment.baseUrl}/videos/`)
  			.toPromise()
  			.then(mapVideos)
  			.catch((err) => {
  				// console.log(err);
  			});
  	}

	numberOfFilms(): Promise<any>  {
  		return this.http
  			.get(`${environment.baseUrl}/videos/`)
  			.toPromise()
  			.then((responce) => {
				return responce.json()['count'];
			})
  			.catch((err) => { console.log(err); });
  	}

  	getNews(): Promise<News> {
		return this.http
			.get(`${environment.baseUrl}/updates/`,
			{headers: this.getHeaders()})
			.toPromise()
			.then(mapNews)
			.catch((err) => {
				this.networkerr = environment.production ? err : '';
			})
  	}

   	getDevTracker(): Promise<DevTracker> {
		return this.http
			.get(`${environment.baseUrl}/devtracker/`,
			{headers: this.getHeaders()})
			.toPromise()
			.then(mapDevPosts)
			.catch((err) => {
				this.networkerr = environment.envName == 'dev' ? err : '';
			})
  	}  	

  	setPlayer(event, id) {
  		this.player[id] = event;
  	}

  	playVideo(video) {

  		this.showIntro = false;	

  		// Pause the current video
		if ( this.player[ this.videoSelection.id ] ) {
			this.player[ this.videoSelection.id ].pauseVideo();
		}

		// Update video on screen
		this.videoSelection = video;
		if( this.player[video.id] ) { // YT Player
			this.player[video.id].playVideo();
		}

		$('html, body').animate({ scrollTop: 0 }, 800);

  	}

	private getHeaders() {
		let headers = new Headers();
		headers.append('Accept', 'application/json');
		return headers;
	}

	private adjustVideo() {
		// Width adjustment
		let width = window.innerWidth;
		let videoplayer = window.document.getElementById('Video');
		if (videoplayer) {
			let rightPush = (videoplayer.clientWidth - width) / 2;
			videoplayer.style.left = '-'+rightPush+'px';	
		}

	}

	sizeFooterButtons() {
		this.buttonsOnScreen = 4;
			this.videosOnScreen = 3;
			this.statsOnScreen = 3;
		let width = window.innerWidth;
		if (width < 768) {
			this.buttonsOnScreen = 1;
			this.videosOnScreen = 1;
			this.statsOnScreen = 1;
		} else if (width < 980) {
			this.buttonsOnScreen = 2;
			this.videosOnScreen = 1;
			this.statsOnScreen = 3;
		} else if (width < 1200) {
			this.buttonsOnScreen = 2;
			this.videosOnScreen = 2;
			this.statsOnScreen = 3;
		} 
	}

	

	preventDefault(e) {
		e.preventDefault();
	}

	// Show more of a post
	showMore(id) {
		// this.expandNews[id] = (this.limit[id] > this.condensedChars)? true : false;
		this.limit[id] = (this.limit[id] == this.condensedChars) ? this.expandedChars : this.condensedChars; 
	}


	scrollTo(numb) { $('html, body').animate({ scrollTop: numb }, 500); }
	goToTop() { this.scrollTo( 0 ); }
	
	createRange(number) {
		var items: number[] = [];
		for(var i = 1; i <= number; i++) { items.push(i); }		
		return items;
	}

	switch() {
		this.loadedUpdates = ( this.loadedUpdates == 'true') ? 'null' : 'true';
		this.loadedPosts = ( this.loadedPosts == 'true') ? 'null' : 'true';
	}

	/* On with the show */
	ngOnInit() {

		Promise.resolve( this.getDevTracker() ).then(posts => {
			this.devPosts = posts;
			this.loadedUpdates = 'true';
		});

		Promise.resolve( this.getNews() ).then(newsItems => {
			this.news = newsItems;
			this.loadedPosts = 'true';
		});

		Promise.resolve( this.getFilms() ).then(vids => {
			this.videos = vids;
			this.videoSelection = this.videos[0];
		});

		Promise.resolve( this.numberOfFilms() ).then(number => {
			this.numberOfVideos = number;
		});

		Promise.resolve( this.storeService.getStatistics() ).then(stats => {
			this.statistics = stats;
		});

		setTimeout( () => {
			this.adjustVideo();	
			this.sizeFooterButtons();
			$('#ShareID').socialShare({
				social: 'blogger,delicious,digg,facebook,google,linkedin,myspace,reddit,stumbleupon,tumblr,twitter'
			});
		}, 200);
	
		window.addEventListener("orientationchange", () => {
		    this.adjustVideo();
		}, false);

		window.addEventListener("resize", () => {
		    this.adjustVideo();
		    this.sizeFooterButtons();
		}, false);

		this.showLogo = true;
		setTimeout( () => {
			this.showInformation = true;
		}, 1500);

		this.showVideoPlayer = false;

	}

	nextSection() {
		this.whatSection();
		this.goToSection(this.viewingSection + 1);
	}


	prevSection() {
		this.whatSection();
		this.goToSection(this.viewingSection - 1);
	}

	nextStats() {
		this.s = (this.s < this.numberOfStatistics-this.statsOnScreen) ? this.s+this.statsOnScreen : this.s;
	}

	prevStats() {
		this.s = (this.s > 0) ? this.s-this.statsOnScreen : this.s;
	}

	countUp(number, current = 0, time = 100) {
		if ( number > current ) {
			setTimeout( () => { this.countUp(number, current, time); }, time);
		}
	}

	/** 
  	* Send the scroll bar to the bottom
  	**/
	toBottom() { 
		this.bottomSignup = true;
		window.scrollTo(0,0); 
	}


	@HostListener('window:scroll', ['$event'])
    	public onWindowScroll(event: Event): void {
			this.lastOffset = window.scrollY;
			event.preventDefault();
			// this.whatSection();
  		}
}


/**
* 		Managing news items
**/

function mapNews(response?:Response): News {
	let res = response.json().map(toNewsFeed);
	return res;
}

function toNewsFeed(r?:any): News {
	let newsItems = <News>({
		tid: r.tid,
		title: r.title,
		title_seo: r.title_seo,
		start_date: r.start_date,
		starter_id: r.starter_id,
		starter_name: r.starter_name,
		topic_firstpost: r.topic_firstpost,
		post: r.post,
		url: r.url,
		author_url: r.author_url,
		comments_url: r.comments_url
	});
	return newsItems;
}


/**
* 		Managing dev posts
**/

function mapDevPosts(response?:Response): DevTracker {
	let res = response.json().map(toDevPost);
	return res;
}

function toDevPost(r?:any): DevTracker {
	let devTrackers = <DevTracker>({
		pid: r.pid,
		topic_id: r.topic_id,
		title: r.title,
		title_seo: r.title_seo,
		post: r.post,
		post_date: r.post_date,
		author: r.author
	});
	return devTrackers;
}


	
/**
*		Mapping Videos
**/

function mapVideos(response?:Response): Video {
	let res = response.json().videos.map(toVideos);
	return res;
}

function toVideos(r?:any): Video {
	let  vids = <Video>({
		id: r.id,
		vid: r.vid,
		title: r.title,
		description: r.description,
		duration: r.duration,
		links: r.links,
		slug: r.slug,
		tags: r.tags,
		images: r.images,
		views: r.views,
		type: r.type,
		published: r.published,
		order: r.order,
		created: r.created
	});
	return  vids;
}



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/home/home.component.ts